import { render, staticRenderFns } from "./ClientNote.vue?vue&type=template&id=9634e11c&"
import script from "./ClientNote.vue?vue&type=script&lang=js&"
export * from "./ClientNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../b_front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports